export default function SharkGodly(props) {
  const {url} = props
  return (
    <div className="godlySharkContainer">
      <video controls>
        <source src={url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}